import { Reorder, useDragControls } from "framer-motion"
import classnames from 'classnames/bind'
import * as styles from './index.module.css'
import { Icon } from '~/components'

const cxs = classnames.bind(styles)

const handleDragStart = (e, handleItemDragStart) => {
    //const el = e.target.closest('.' + styles.row)
    //if (el) el.classList.add(styles.dragging)
    if(handleItemDragStart) handleItemDragStart(e);
  }

const handleDragEnd = (e, handleItemDragEnd) => {
  //const el = e.target.closest('.' + styles.row)
  //if (el) el.classList.remove(styles.dragging)
  if(handleItemDragEnd) handleItemDragEnd(e);
  // setDraggable(false)
  // updateValues(fields)
}

/*
onMouseEnter={() => setDraggable(true)}
          onMouseLeave={() => setDraggable(false)} // retain this for better animation
          onTouchStart={() => setDraggable(true)} // for mobile: need to set draggable to `false` in `onDragEnd` prop, not `onTouchEnd`
 onDragStart={(e) => handleDragStart(e, handleItemDragStart)}
      onDragEnd={(e) => handleDragEnd(e, handleItemDragEnd)}
          dragConstraints={ref}
          */
/*
onDragStart={handleDragStart}
      onDragEnd={handleDragEnd} 
onDragStart={(e) => handleDragStart(e, handleItemDragStart)}
      onDragEnd={(e) => handleDragEnd(e, handleItemDragEnd)}


      
*/
function LocationItem({ item, dragConstraints, isReorderEnabled, reorderKey, handleItemDragStart, handleItemDragEnd, handleRemove}) {
  const controls = useDragControls()
  const index = item?.element?.props?.fieldIndex || 0;

  return (
    <Reorder.Item
      key={reorderKey} 
      value={item}
      dragConstraints={dragConstraints}
      dragListener={false}
      dragControls={controls}
      onDragEnd={(e) => handleDragEnd(e, handleItemDragEnd)}
      initial={{ opacity: 0, y: 0 }}
      animate={{
        opacity: 1,
        y: 0,
        transition: { duration: 0 }
      }}
        
      dragElastic={0.05}
      
      className={styles.row}
    >
      <div className={styles.field}>
        {item.element}
        <div className={cxs(styles.dragHandle, { enabled: isReorderEnabled })}
          onPointerDown={(e) => controls.start(e)}
          
        >
          <Icon id="drag" />
        </div>
      </div>
      <button onClick={() => {console.log(item.element); handleRemove(index)}} className={styles.removeButton} tabIndex="-1">
        <div className={styles.removeBackground}>
          <Icon id="plus" />
        </div>
      </button>
    </Reorder.Item>
  )
}

export default LocationItem
